import React from 'react'

const DownloadIcon = ({ color = '#333' }: { color?: string }) => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    stroke={color}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6471 5.03913H8.50981V0.333252H3.80393V5.03913H0.666672L6.15687 10.5293L11.6471 5.03913ZM0.666672 12.098V13.6666H11.6471V12.098H0.666672Z"
      fill={color}
    />
  </svg>
)

export default DownloadIcon
